const Success = () => (
  <svg
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27.4191 44.5966L0 95.8542L55.4189 78.2414L27.4191 44.5966Z"
      fill="#0A0777"
    />
    <path
      d="M45.5162 57.9842C40.7098 52.1778 41.484 43.5972 47.2903 38.7585L56.0322 49.2423L64.774 59.7261C58.9354 64.5648 50.3226 63.7906 45.5162 57.9842Z"
      fill="#C9E3F7"
    />
    <path
      d="M55.9999 49.2736C49.9677 42.0156 50.9354 31.2415 58.1934 25.177L69.1288 38.3382L80.0642 51.4993C72.8385 57.4993 62.0644 56.5316 55.9999 49.2736Z"
      fill="#C9E3F7"
    />
    <path
      d="M69.1609 38.3384C61.419 29.0482 62.7094 15.2419 71.9996 7.5L85.9995 24.3386L99.9994 41.1771C90.6769 48.8867 76.9028 47.6287 69.1609 38.3384Z"
      fill="#C9E3F7"
    />
    <path
      d="M34.8057 34.596C37.3177 34.596 39.354 32.5596 39.354 30.0476C39.354 27.5356 37.3177 25.4993 34.8057 25.4993C32.2937 25.4993 30.2573 27.5356 30.2573 30.0476C30.2573 32.5596 32.2937 34.596 34.8057 34.596Z"
      fill="#0A0777"
    />
    <path
      d="M94.2212 67.0806C96.7331 67.0806 98.7695 65.0442 98.7695 62.5322C98.7695 60.0203 96.7331 57.9839 94.2212 57.9839C91.7092 57.9839 89.6729 60.0203 89.6729 62.5322C89.6729 65.0442 91.7092 67.0806 94.2212 67.0806Z"
      fill="#FFCCEF"
    />
  </svg>
);

export default Success;
